import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
import { HomePage } from './main';
import { authRoutes } from './auth';
import { admindashboardRoutes } from './admin-dashboard';
import { componentsRoutes } from './components';
import ContactUs from 'src/pages/contactUs';
import AboutUsPage from 'src/sections/about/view/about-view';
import { lazy } from 'react';

const TermsOfService = lazy(() => import('src/pages/terms-of-service'));
const PrivacyPolicy = lazy(() => import('src/pages/privacy-policy'));



export default function Router() {

  return useRoutes([
    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    {
      path: "/terms-of-service",
      element: (<MainLayout>
        <TermsOfService />
      </MainLayout>)
    },
    {
      path: '/privacy-policy',
      element: (<MainLayout>
        <PrivacyPolicy />
      </MainLayout>)
    },

    {
      path: '/contact-us',
      element: (<MainLayout>
        <ContactUs />
      </MainLayout>
      ),
    },

    {
      path: '/about-us',
      element: (<MainLayout>
      <AboutUsPage />
      </MainLayout>),
    },

    ...authRoutes,
    ...admindashboardRoutes,
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
